var map = {
	"./admin": 8734,
	"./admin.js": 8734,
	"./category/[id]": 2538,
	"./category/[id].js": 2538,
	"./category/addPost": 2761,
	"./category/addPost.js": 2761,
	"./discover": 1874,
	"./discover.js": 1874,
	"./hashtag/[id]": 6578,
	"./hashtag/[id].js": 6578,
	"./home": 6684,
	"./home.js": 6684,
	"./landing": 8011,
	"./landing.js": 8011,
	"./login": 7400,
	"./login.js": 7400,
	"./message": 6290,
	"./message/": 6290,
	"./message/[id]": 3978,
	"./message/[id].js": 3978,
	"./message/index": 6290,
	"./message/index.js": 6290,
	"./post/[id]": 6161,
	"./post/[id].js": 6161,
	"./profile/[id]": 9905,
	"./profile/[id].js": 9905,
	"./publication/[id]": 8744,
	"./publication/[id].js": 8744,
	"./register": 8407,
	"./register.js": 8407,
	"./search": 8630,
	"./search.js": 8630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2150;